<template>
	<div
		:class="['panel', 'research_header_3',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div class="row align-items-center">
				<div class="col-12 col-lg-5">
					<div
						v-if="isHeaderVisible"
						:class="[
							'panel_header',
							isBrand? 'sk' : '',
						]"
					>
						<h2>
							{{ block.block_title }}
						</h2>
					</div>
					<div class="content description" v-html="block.content.description" />
				</div>
				<div class="col-12 col-lg-6 offset-lg-1">
					<div class="title">
						{{ block.content.diagram_title }}
					</div>
					<b-embed
						type="iframe"
						:aspect="$device.isDesktop?block.content.proportions:block.content.proportions_mobile"
						:src="block.content.diagram"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'ResearchChart',
	mixins: [panel],
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/research-chart-headers";
</style>
